export default import.meta.ROLLUP_FILE_URL_DKl0kaC1;